import styled from 'styled-components';
import { InteriorSelectStyled } from '../InteriorSelectStyled';
import { rem } from 'polished';

export const InteriorSelectStyledAC = styled(InteriorSelectStyled)`
    .interiorTitle {
        color: ${({ theme }) => theme.colors.grey5};
        font-size: ${({ theme }) => theme.fontSizes.h4};
        .icon {
            background: ${({ theme }) => theme.colors.white};
            .selected {
                background: ${({ theme }) => theme.colors.blue2};
                width: ${rem(14)};
                height: ${rem(14)};
                top: ${rem(4)};
                left: ${rem(4)};
            }
        }
    }

    .react-multiple-carousel__arrow {
        border-width: 2px;
        border-radius: 10px;
        border-color: ${({ theme }) => theme.colors.red};

        &:hover,
        &:focus-visible {
            border-color: ${({ theme }) => theme.colors.grey5};
            background: ${({ theme }) => theme.colors.white};

            &::before {
                color: ${({ theme }) => theme.colors.grey5};
            }
        }

        &::before {
            color: ${({ theme }) => theme.colors.red};
        }
    }

    .interiorPrice {
        color: ${({ theme }) => theme.colors.grey5};
    }

    .interior {
        border-radius: ${rem(12)};

        &.isSelected,
        &:hover,
        &:focus-visible {
            border: 1px solid ${({ theme }) => theme.colors.blue2};
            .inner {
                border-color: ${({ theme }) => theme.colors.blue};
                border-radius: ${rem(10)};
            }
        }
    }

    .isSelected {
        background: rgba(157, 199, 224, 0.2);
    }
`;
